export const center_app_version = {"commit_sha": "3f8ad827"}
